import { SiReact } from 'react-icons/si'

export const ReactTech = () => {
    return (
        <div>
        <SiReact />
        <h4>React</h4>
        </div>
    )
}